import React, { useEffect, useState } from 'react';

function isFinePointerDevice() {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false;
  }

  return window.matchMedia('(pointer: fine)').matches;
}

export default function CursorLayer() {
  const [enabled, setEnabled] = useState(false);
  const [isInteractive, setIsInteractive] = useState(false);
  const [cursor, setCursor] = useState({ x: -100, y: -100 });
  const [ring, setRing] = useState({ x: -100, y: -100 });

  useEffect(() => {
    setEnabled(isFinePointerDevice());
  }, []);

  useEffect(() => {
    if (!enabled) {
      return undefined;
    }

    let animationFrameId = 0;
    let ringX = -100;
    let ringY = -100;
    let targetX = -100;
    let targetY = -100;

    const handleMouseMove = (event) => {
      targetX = event.clientX;
      targetY = event.clientY;
      setCursor({ x: targetX, y: targetY });
    };

    const handlePointerState = (event) => {
      const target = event.target;
      if (!(target instanceof Element)) {
        setIsInteractive(false);
        return;
      }

      const interactiveElement = target.closest(
        'a, button, input, select, textarea, label, [data-cursor-interactive="true"]',
      );

      setIsInteractive(Boolean(interactiveElement));
    };

    const loop = () => {
      ringX += (targetX - ringX) * 0.14;
      ringY += (targetY - ringY) * 0.14;
      setRing({ x: ringX, y: ringY });
      animationFrameId = window.requestAnimationFrame(loop);
    };

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseover', handlePointerState);
    animationFrameId = window.requestAnimationFrame(loop);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseover', handlePointerState);
      window.cancelAnimationFrame(animationFrameId);
    };
  }, [enabled]);

  if (!enabled) {
    return null;
  }

  return (
    <>
      <span
        className={`cursor-dot ${isInteractive ? 'cursor-dot-active' : ''}`}
        style={{
          left: cursor.x,
          top: cursor.y,
        }}
      />
      <span
        className={`cursor-ring ${isInteractive ? 'cursor-ring-active' : ''}`}
        style={{
          left: ring.x,
          top: ring.y,
        }}
      />
    </>
  );
}
